<template>
  <v-card>
    <v-sheet color="#f3f5f6">
      <v-card-title class="d-flex flex-column align-start px-4 px-sm-6">
        <TitleWidget small>Criar link de compartilhamento</TitleWidget>

        <div class="d-flex align-center">
          <v-icon
            color="grey darken-1"
            style="margin-top: 2px"
            :size="xsOnly ? 14 : 16"
          >
            mdi-map-marker-outline
          </v-icon>

          <div class="secondary--text text-body-2 text-sm-body-1 ml-1">
            {{ item.nome }}
          </div>
        </div>
        <v-btn
          @click.prevent="$emit('close')"
          color="black"
          :small="xsOnly"
          absolute
          right
          icon
          top
        >
          <v-icon size="18">mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
    </v-sheet>
    <v-divider />

    <v-card-text class="px-4 px-sm-6">
      <v-card class="rounded-lg pa-4 mt-4 mt-sm-6" outlined>
        <div
          class="grey--text text--darken-1 text-caption text-uppercase font-weight-medium"
        >
          Dados do Destinatário
        </div>

        <div class="grid-list-informations mt-1">
          <div>
            <label
              class="d-flex align-center text-caption font-weight-medium mb-1"
              for="name"
            >
              <v-icon class="mr-1" size="14"> mdi-account </v-icon>
              Nome
            </label>

            <v-text-field
              v-model="nome"
              id="name"
              class="form-control"
              placeholder="Nome Completo"
              name="nome"
              hide-details
              outlined
              dense
            />
          </div>

          <div>
            <label
              class="d-flex align-center text-caption font-weight-medium mb-1"
              for="tel"
            >
              <v-icon class="mr-1" size="14"> mdi-phone </v-icon>
              Telefone
            </label>

            <v-text-field
              v-model="telefone"
              @input="telefone = maskPhone(telefone)"
              @keypress="fnOnlyNumber"
              id="tel"
              class="form-control"
              placeholder="(00) 00000-0000"
              name="telefone"
              maxlength="15"
              hide-details
              outlined
              dense
            />
          </div>
        </div>
      </v-card>

      <v-sheet
        class="d-flex flex-column flex-sm-row align-sm-center justify-space-between mt-4"
        color="transparent"
        width="100%"
      >
        <div class="text-body-2 font-weight-medium">
          Selecione os itens para compartilhar
        </div>

        <div class="mt-1 mt-sm-0">
          <v-btn
            @click.prevent="checkAll()"
            color="#dbdee1"
            height="32px"
            outlined
            small
          >
            <div class="black--text text-none">Selecionar tudo</div>
          </v-btn>

          <v-btn
            @click.prevent="checkAll(false)"
            class="ml-1"
            color="error"
            height="32px"
            small
            text
          >
            <div class="text-none">Limpar</div>
          </v-btn>
        </div>
      </v-sheet>

      <div>
        <v-card
          v-for="(fields, category) in linkCategories"
          :key="category"
          class="rounded-lg mt-4"
          outlined
        >
          <v-sheet color="#f3f5f6">
            <v-card-title class="px-4 py-2">
              <div class="font-weight-medium">
                <v-checkbox
                  @change="toggleCategory(fields, $event)"
                  class="checkbox-links"
                  color="primary"
                  off-icon="mdi-checkbox-blank-outline"
                  on-icon="mdi-checkbox-marked-outline"
                  :input-value="isCategoryChecked(fields)"
                  :label="category"
                  hide-details
                  dense
                />
              </div>
            </v-card-title>
          </v-sheet>

          <v-card-text class="py-3">
            <div class="grid-list">
              <div v-for="field in fields" :key="field">
                <v-checkbox
                  v-model="linkFazenda[field]"
                  class="checkbox-links"
                  color="primary"
                  off-icon="mdi-checkbox-blank-outline"
                  on-icon="mdi-checkbox-marked-outline"
                  :label="labels[field]"
                  hide-details
                  dense
                />
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-card-text>

    <v-divider />
    <v-card-actions class="px-4 px-sm-6 py-4">
      <v-sheet class="d-flex align-center justify-space-between" width="100%">
        <div class="text-caption text-sm-body-1 grey--text">
          {{ checkedCount }}
        </div>

        <div>
          <v-btn
            @click="$emit('close')"
            class="rounded-lg"
            color="#cccccc"
            :disabled="isLoading"
            :small="xsOnly"
            outlined
          >
            <div class="black--text text-none">Cancelar</div>
          </v-btn>

          <v-btn
            @click="onSendCreateLink"
            class="white--text ml-1 ml-sm-2 rounded-lg"
            color="orange"
            :disabled="isLoading"
            :loading="isLoading"
            :small="xsOnly"
            depressed
            dark
          >
            <v-icon size="18">mdi-content-save</v-icon>
            <div class="text-body-1 text-none font-weight-medium ml-2">
              Criar link
            </div>
          </v-btn>
        </div>
      </v-sheet>
    </v-card-actions>
  </v-card>
</template>

<script>
import TitleWidget from "@/components/widgets/Title.vue";
import maskPhone from "@/utils/maskPhone";
import { mapActions } from "vuex";

const _labels = {
  mapa: "Mapa",
  download: "Baixar KMZ",
  informacoes: "Informações",
  benfeitorias: "Benfeitorias",
  informacoes_diversas: "Informações diversas",
  documentos_ambientais: "Documentos ambientais",
  documentos_fundiarios: "Documentos fundiários",
  documentos_diversos: "Documentos diversos",
  fotos: "Fotos",
  videos: "Vídeos",
  dados_captador: "Dados do captador",
};

export default {
  components: { TitleWidget },
  props: {
    item: Object,
  },
  data: () => ({
    isLoading: false,
    linkCategories: {
      Gerais: [
        "informacoes",
        "mapa",
        "informacoes_diversas",
        "download",
        "benfeitorias",
      ],
      Midia: ["fotos", "videos"],
      Documentos: [
        "documentos_ambientais",
        "documentos_diversos",
        "documentos_fundiarios",
      ],
      Cadastros: ["dados_captador"],
    },
    labels: _labels,
    linkFazenda: {
      ...Object.fromEntries(Object.keys(_labels).map((key) => [key, false])),
    },
    nome: "",
    telefone: "",
  }),
  computed: {
    checkedCount() {
      const total = Object.entries(this.linkFazenda).filter(
        ([, value]) => value === true,
      ).length;

      if (total > 1) return `${total} itens selecionados`;

      return `${total} item selecionado`;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    ...mapActions("properties", ["createLink"]),
    async onSendCreateLink() {
      this.isLoading = true;

      const resp = await this.createLink({
        fazenda_id: this.item.id,
        ...this.linkFazenda,
        nome: this.nome,
        telefone: this.telefone,
      });

      if (resp) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-link-variant-plus",
          message: "Link cadastrado com sucesso.",
          type: "success",
        });

        const linkCreated = window.location.origin + "/link/" + resp.token;

        this.$emit("close");
        this.$emit("success", linkCreated);
      } else {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-link-variant-off",
          message: "Erro ao cadastrar link.",
          type: "error",
        });
      }

      this.isLoading = false;
    },
    checkAll(is = true) {
      Object.keys(this.linkFazenda).forEach((key) => {
        this.$set(this.linkFazenda, key, is);
      });
    },
    toggleCategory(fields, value) {
      fields.forEach((field) => {
        this.$set(this.linkFazenda, field, value);
      });
    },
    isCategoryChecked(fields) {
      return fields.every((field) => this.linkFazenda[field]);
    },
    fnOnlyNumber(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    maskPhone,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
  }
}

.checkbox-links::v-deep {
  margin-top: 0;
  padding-top: 0;

  .v-input--selection-controls__input {
    margin-right: 2px;

    .v-input--selection-controls__ripple {
      height: 24px;
      left: calc(50% - 12px);
      margin: 0;
      top: calc(50% - 12px);
      width: 24px;
    }

    .v-icon {
      color: #999999;
      font-size: 18px;
    }
  }

  label {
    color: #000000;
  }
}

.grid-list-informations {
  display: grid;
  gap: 12px;
  grid-template-columns: calc(70% - 6px) calc(30% - 6px);

  @media screen and (max-width: 599.9px) {
    grid-template-columns: 1fr;
  }
}
</style>
